import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../api/auth';

const SECTIONS = [
  { to: '/organs', label: 'Organs' },
  { to: '/diseases', label: 'Diseases' },
  { to: '/wheel', label: 'Wheel' },
  { to: '/cards', label: 'Cards' },
  { to: '/config', label: 'Game config' },
  { to: '/users', label: 'Users' },
  { to: '/audit', label: 'Audit' },
];

export function Layout() {
  const { admin, signOut } = useAuth();

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">
          <strong>PATHOLOGY</strong>
          <span>admin</span>
        </div>
        <nav>
          {SECTIONS.map((section) => (
            <NavLink
              key={section.to}
              to={section.to}
              className={({ isActive }) => (isActive ? 'nav-link nav-link-active' : 'nav-link')}
            >
              {section.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-foot">
          <span className="muted">{admin?.email}</span>
          <button className="button button-ghost" onClick={() => void signOut()}>
            Sign out
          </button>
        </div>
      </aside>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
